import React, {Suspense, useEffect} from "react";
import ArticleCategoriesContainer from "../../../../articles/ArticleCategoriesContainer";
import {useSelector} from "react-redux";
import {fetchBuilderSettingByKey} from "../../../../../../helpers/MethodHelper";
import Checkers from "../../../../../../helpers/class/Checkers";
import {useApiGet} from "../../../../../../hooks/useApiHook";

interface ExperiencesDestinationProps {
    experiences: any
    app_data: any
    app: any
    builder: any
}
export const ExperiencesDestination = ({experiences, app, app_data, builder} : ExperiencesDestinationProps) => {

    const isPublicDomain = useSelector(state => Checkers.valueToBoolean(state['appSettings']['isPublicDomain']) )

    const epxperiencesViewType = useSelector(
        state => fetchBuilderSettingByKey(state['builderSettingsData'], 'builder_singleproperty_experiences_view_type')
    );

    const experiencesSubtitle = useSelector(
        state => fetchBuilderSettingByKey(state['builderSettingsData'], 'builder_singleproperty_experiences_subtitle')
    );

    const experiencesShowCategories = useSelector(
        state => Checkers.valueToBoolean(fetchBuilderSettingByKey(state['builderSettingsData'], 'builder_singleproperty_experiences_show_categories'))
    );

    const pageId = useSelector(state => state['propertiesParams']['page_id']);

    // const experiencesTest = fetchHomepageExperiencesCategoriesData(redis, pageId)

    const experiensesGenericWidget = useApiGet('/api/lodge/frontend/get/experiences/category/content', 'page_id='+pageId+'&experience_category_id=generic', false)

    const collectionItemsBtnLabel = useSelector(
        state => fetchBuilderSettingByKey(state['builderSettingsData'], 'builder_homepage_experiences_btn_label')
    );

    const isDesktop = useSelector(state => state['appSettings']['isDesktop']);

    return (
        <>
            {

                !isPublicDomain
                    ?
                    <>
                        {
                            experiencesShowCategories && !experiensesGenericWidget.loading && experiensesGenericWidget.data != null ?
                                <>
                                    <ArticleCategoriesContainer
                                        key={'exp-categories-content-container'}
                                        app_data={app_data}
                                        app={app}
                                        builder={builder}
                                        type={'experiences'}
                                        content={experiensesGenericWidget.data}
                                        isDesktop={isDesktop}
                                        articlesCategories={null}
                                        categoryIdInhrerited={"generic"}
                                        includeJumbotron={false}
                                        includeTitle={true}
                                        itemWrapperClassName={'d-flex col-12 col-sm-6 col-md-4 col-lg-4'}
                                        itemClassName={'experience-design-box'}
                                        showAllLabel={collectionItemsBtnLabel}
                                        titleClassName={'d-block text-left '}
                                        paddingTopClassName={'pt-5'}
                                        articlesLimit={3}
                                    />
                                </>
                                :
                                <>
                                    {
                                        experiences!=null && experiences.length > 0 ?
                                            experiences.map((item, index) => {

                                                return (
                                                    <React.Fragment key={'fragment' + index} >
                                                        <Suspense>
                                                            <ArticleCategoriesContainer
                                                                key={index}
                                                                app_data={app_data}
                                                                app={app}
                                                                builder={builder}
                                                                type={'experiences'}
                                                                content={item}
                                                                isDesktop={true}
                                                                articlesCategories={null}
                                                                categoryIdInhrerited={item.id}
                                                                includeJumbotron={false}
                                                                includeTitle={!item.hide_title}
                                                                inheritedViewType={epxperiencesViewType}
                                                                itemClassName={'experience-design-box'}
                                                                itemWrapperClassName={'d-flex col-12 col-sm-6 col-md-4 col-lg-4'}
                                                                titleClassName={'justify-content-left text-left d-block '}
                                                                subtitleInherited={experiencesSubtitle}
                                                                paddingTopClassName={''}
                                                                viewMoreBtnStyle={'secondary'}
                                                                articlesLimit={3}
                                                            />
                                                        </Suspense>
                                                    </React.Fragment>
                                                )
                                            })
                                            :
                                            <></>
                                    }
                                </>
                        }
                    </>
                    :
                    <></>
            }
        </>
    )
}